import type { Next } from '@wix/funnel-builder-lizard'

import type { PageLogger } from '../../../../../bi/mfi'
import { Save } from '../../../../../context/StorageContext/StorageContext'
import type { Option } from '../../Content'
import { getBIAnswer } from '../getBIAnswer'
import type { State } from '../index'

type GoNextParams = {
  isPageLoading: boolean
  value: State['value']
  options: Option[]
  pageLogger: PageLogger
  next: Next
  questionKey: string
  save: Save
}

export const goNext = (params: GoNextParams) => {
  const { isPageLoading, value, options, save, pageLogger, next, questionKey } = params

  if (isPageLoading) {
    return
  }

  const answer = getBIAnswer({ options, value })
  void pageLogger.answer({ answer })

  const values = Object.keys(value).filter(id => value[id])
  const appDefIds = options
    .filter(o => values.includes(o.optionKey))
    .map(o => o.appDefId)
    .filter(i => i) as string[]
  save({ appDefIds })
  next({ [questionKey]: { values } })
}
